import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundInvoice.List.IRequest;
type Response = Api.Sales.ContractRefundInvoice.List.IResponse;
type Headers = Api.Sales.ContractRefundInvoice.List.IHeaders;
const url = '/api/Sales/ContractRefundInvoice';
export default async function contractRefundInvoiceListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
